import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-6" }
const _hoisted_5 = { class: "form-group mb-15" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Titre "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1)
const _hoisted_7 = { class: "col-md-6" }
const _hoisted_8 = { class: "form-group mb-15" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Position "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1)
const _hoisted_10 = { class: "col-md-6" }
const _hoisted_11 = { class: "form-group mb-15" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Lien "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1)
const _hoisted_13 = { class: "col-md-6" }
const _hoisted_14 = { class: "form-group mb-15" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Menu Parent ", -1)
const _hoisted_16 = { class: "col-md-6" }
const _hoisted_17 = { class: "form-group mb-15" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Catégories ", -1)
const _hoisted_19 = { class: "col-md-6" }
const _hoisted_20 = { class: "form-group mb-15" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Image principale", -1)
const _hoisted_22 = {
  ref: "imageInput",
  type: "file",
  name: "image",
  accept: "image/jpeg, image/png",
  class: "form-control shadow-none fs-md-15 text-black"
}
const _hoisted_23 = { class: "col-md-6" }
const _hoisted_24 = { class: "form-group mb-15" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Icone", -1)
const _hoisted_26 = {
  ref: "iconeInput",
  type: "file",
  name: "icone",
  accept: "image/jpeg, image/png",
  class: "form-control shadow-none fs-md-15 text-black"
}
const _hoisted_27 = { class: "col-md-12" }
const _hoisted_28 = { class: "d-flex align-items-center" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 rounded-1 fs-md-15 fs-lg-16 bg-success"
}, " Modifier ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Form, {
        onSubmit: _ctx.editMenu,
        "validation-schema": _ctx.MenuSchema
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createVNode(_component_Field, {
                  name: "titre",
                  type: "text",
                  class: "form-control shadow-none fs-md-15 text-black",
                  modelValue: _ctx.formData.titre,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.titre) = $event))
                }, null, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "titre",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createVNode(_component_Field, {
                  name: "position",
                  type: "text",
                  class: "form-control shadow-none fs-md-15 text-black",
                  modelValue: _ctx.formData.position,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.position) = $event))
                }, null, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "position",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createVNode(_component_Field, {
                  name: "lien",
                  type: "text",
                  class: "form-control shadow-none fs-md-15 text-black",
                  modelValue: _ctx.formData.lien,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.lien) = $event))
                }, null, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "lien",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _createVNode(_component_Field, { name: "menu_parent_id" }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, {
                      options: _ctx.MenusOptions,
                      modelValue: _ctx.selectedParentId,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedParentId) = $event)),
                      "track-by": "value",
                      label: "label",
                      placeholder: "Sélectionner un menu parent (facultatif)",
                      "can-clear": true,
                      onChange: ($event: any) => (field.onChange($event))
                    }, null, 8, ["options", "modelValue", "onChange"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "menu_parent_id",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _createVNode(_component_Field, { name: "categorie_ids" }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, {
                      options: _ctx.categorieArticlesOptions,
                      modelValue: _ctx.selectedCategorieIds,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedCategorieIds) = $event)),
                      "track-by": "value",
                      label: "label",
                      mode: "tags",
                      placeholder: "Sélectionner des catégories",
                      onSelect: ($event: any) => (field.onChange(_ctx.selectedCategorieIds)),
                      onRemove: ($event: any) => (field.onChange(_ctx.selectedCategorieIds))
                    }, null, 8, ["options", "modelValue", "onSelect", "onRemove"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "categorie_ids",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                _createElementVNode("input", _hoisted_22, null, 512),
                _createVNode(_component_ErrorMessage, {
                  name: "image",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _hoisted_25,
                _createElementVNode("input", _hoisted_26, null, 512),
                _createVNode(_component_ErrorMessage, {
                  name: "icone",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _hoisted_29,
                _createVNode(_component_router_link, {
                  to: "/liste-menus",
                  class: "btn btn-danger transition border-0"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Annuler ")
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema"])
    ])
  ]))
}